const TRAILING_SLASHES_PATTERN = /\/+$/

export function getFeedPreviewApiUrl(isDev = import.meta.env.DEV, configuredURL = import.meta.env.VITE_FEED_PREVIEW_API_URL) {
  return isDev ? (configuredURL || 'http://localhost:8081').replace(TRAILING_SLASHES_PATTERN, '') : ''
}
